import React from "react";
import { graphql } from "gatsby";
import { Link } from "gatsby";
import Layout from "../components/layout";
import SEO from "../components/seo";

class NotFoundPage extends React.Component {
  render() {
    return (
      <Layout>
        <SEO title="404: Not Found" />
        <h1>Not Found</h1>
        <p>
          Sorry, the page you requested does not exist. No worries, there are
          plenty of good things that do exist:
        </p>
        <p>
          <Link to="/">My Blog</Link>
        </p>
        <p>
          <Link to="/products">Products</Link>
        </p>
        <p>
          <Link to="/about">About Me</Link>
        </p>
      </Layout>
    );
  }
}

export default NotFoundPage;

export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        title
      }
    }
  }
`;
